/**
 * 관리자 지역 통계 API 서비스
 */

import { apiGet } from "./apiClient";

/**
 * 지역별 월별 판매 통계 조회 (가맹점)
 * @param {string} addr - 구/군 주소
 * @returns {Promise} 월별 판매 데이터
 */
export const getRegionStatistics = async ({ addrDo, addrSi, addrGuGun }) => {
  try {
    const params = new URLSearchParams();
    if (addrDo) params.append("addrDo", addrDo);
    if (addrSi) params.append("addrSi", addrSi);
    if (addrGuGun) params.append("addrGuGun", addrGuGun);
    const response = await apiGet(`/admin/stat/store?${params.toString()}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "지역 통계 조회 실패",
      };
    }
  } catch (error) {
    console.error("지역 통계 조회 중 오류:", error);
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};

/**
 * 지역별 월별 판매 통계 조회 (고객)
 * @param {string} addr - 구/군 주소
 * @returns {Promise} 월별 판매 데이터
 */
export const getCustStatistics = async ({ addrDo, addrSi, addrGuGun }) => {
  try {
    const params = new URLSearchParams();
    if (addrDo) params.append("addrDo", addrDo);
    if (addrSi) params.append("addrSi", addrSi);
    if (addrGuGun) params.append("addrGuGun", addrGuGun);
    const response = await apiGet(`/admin/stat/cust?${params.toString()}`);

    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        data: data,
        error: null,
      };
    } else {
      return {
        success: false,
        data: null,
        error: "고객 통계 조회 실패",
      };
    }
  } catch (error) {
    console.error("고객 통계 조회 중 오류:", error);
    return {
      success: false,
      data: null,
      error: "네트워크 오류가 발생했습니다.",
    };
  }
};
